import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var RichText = function RichText(_ref) {
  var alignCenter = _ref.alignCenter,
      children = _ref.children,
      compact = _ref.compact,
      large = _ref.large;
  var getClassName = getClassNameFactory(RichText.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(alignCenter && "alignCenter", compact && "compact", large && "large")
    })
  }, children);
};

RichText.displayName = "RichText";
export default RichText;